import { types } from 'mobx-state-tree';
import { Instance } from 'mobx-state-tree';
import { DateTimeType, withDateProcessors } from './DateTimeUtility';
export const Template = withDateProcessors(types.model('Template', {
  id: types.identifier,
  name: types.maybeNull(types.string),
  tasks_count: types.maybeNull(types.number),
  assignments_count: types.maybeNull(types.number),
  created_at: DateTimeType,
  updated_at: DateTimeType
}).actions(self => ({})));
export type ITemplate = Instance<typeof Template>;